import React from "react";
import { Type } from "./_.styled";

const PageDescription = ({ children, adornment, className, ...props }) => (
  <Type
    className={`description ${className || ""}`}
    element="p"
    fontSize="sm"
    {...props}
  >
    <span dangerouslySetInnerHTML={{ __html: children }} />
    {adornment}
  </Type>
);

export default PageDescription;
